import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../Loader';
import useDebounce from '../../../utils/useDebounce';

const ProReservationsToolbar = (props) => {
  const {
    email,
    setEmail,
    name,
    setName,
    eventSlugName,
    setEventSlugName,
    payed,
    setPayed,
    startDate,
    setStartDate,
    finishDate,
    setFinishDate,
    eventsList,
    handleDownload,
    downloadingInProgress,
  } = props;

  const [localEmail, setLocalEmail] = useState(email || '');
  const [localName, setLocalName] = useState(name || '');
  const debouncedEmail = useDebounce(localEmail, 500);
  const debouncedName = useDebounce(localName, 500);

  useEffect(() => {
    setEmail(debouncedEmail || null);
  }, [debouncedEmail]);

  useEffect(() => {
    setName(debouncedName || null);
  }, [debouncedName]);

  return (
    <div>
      <div className="flex flex-wrap items-end mb-4">

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">Name</label>
          <input
            type="text"
            className="border border-black px-2 py-1 text-sm"
            placeholder="Search by name..."
            value={localName}
            onChange={e => setLocalName(e.target.value)}
          />
        </div>

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">Email</label>
          <input
            type="text"
            className="border border-black px-2 py-1 text-sm"
            placeholder="Search by email..."
            value={localEmail}
            onChange={e => setLocalEmail(e.target.value)}
          />
        </div>

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">Event</label>
          <select
            className="border border-black px-2 py-1 text-sm"
            value={eventSlugName || ''}
            onChange={e => setEventSlugName(e.target.value || null)}
          >
            <option value="">All events</option>
            {eventsList && eventsList.map(event => (
              <option key={event.eventSlugName} value={event.eventSlugName}>
                {event.eventName}
              </option>
            ))}
          </select>
        </div>

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">Reserved</label>
          <select
            className="border border-black px-2 py-1 text-sm"
            value={payed === null ? '' : payed.toString()}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '') setPayed(null);
              else if (val === 'true') setPayed(true);
              else setPayed(false);
            }}
          >
            <option value="">All</option>
            <option value="true">Reserved</option>
            <option value="false">Not reserved</option>
          </select>
        </div>

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">From</label>
          <input
            type="date"
            className="border border-black px-2 py-1 text-sm"
            value={startDate || ''}
            onChange={e => setStartDate(e.target.value || null)}
          />
        </div>

        <div className="mr-4 mb-2">
          <label className="block font-americaMonoBold text-xs uppercase mb-1">To</label>
          <input
            type="date"
            className="border border-black px-2 py-1 text-sm"
            value={finishDate || ''}
            onChange={e => setFinishDate(e.target.value || null)}
          />
        </div>

        <div className="mr-4 mb-2">
          {downloadingInProgress ? (
            <Loader type="Oval" color="#000" height={20} width={20} />
          ) : (
            <button
              type="button"
              className="font-americaMonoBold text-xs px-6 py-1 border-black border rounded-full bg-transparent text-black uppercase"
              onClick={handleDownload}
            >
              Download CSV
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

ProReservationsToolbar.propTypes = {
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  name: PropTypes.string,
  setName: PropTypes.func.isRequired,
  eventSlugName: PropTypes.string,
  setEventSlugName: PropTypes.func.isRequired,
  payed: PropTypes.bool,
  setPayed: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  setStartDate: PropTypes.func.isRequired,
  finishDate: PropTypes.string,
  setFinishDate: PropTypes.func.isRequired,
  eventsList: PropTypes.arrayOf(PropTypes.shape({})),
  handleDownload: PropTypes.func.isRequired,
  downloadingInProgress: PropTypes.bool.isRequired,
};

ProReservationsToolbar.defaultProps = {
  email: null,
  name: null,
  eventSlugName: null,
  payed: null,
  startDate: null,
  finishDate: null,
  eventsList: [],
};

export default ProReservationsToolbar;
